module.exports = __webpack_public_path__ + "static/media/capy_page_area03_img_cn@2x.9e9d9406.jpg";